import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatNumber } from "utils/formatHelper";
import moment from "moment";
import { ROUTES } from "base/routes/routes";
import { toast } from "react-toastify";

// Components
import LoadingScreen from "base/ui/components/LoadingScreen/loadingScreen";

// Icons
import { IoAddSharp, IoArrowBackCircle } from "react-icons/io5";

// Models
import {
  DetailHistoryReceiveModel,
  HistoryReceives,
} from "services/historyReceive_sevieces";

// Stores
import {
  historyReceivePresenter,
  historyReceiveStore,
} from "stores/root_store";
import { FaSave } from "react-icons/fa";
import { BiSave } from "react-icons/bi";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { getUserSession } from "utils/localStorageHelper";
import { User } from "services/user_services";
export function createHistoryReceiveDetail() {
  const column = [
    {
      columnName: "STT",
      align: "text-center",
      visible: true,
    },
    { columnName: "Số LOT", align: "text-center", visible: true },

    { columnName: "Số lượng nhập kho", align: "text-center", visible: true },

    {
      columnName: "ĐVT",
      align: "text-center",
      visible: true,
    },

    { columnName: "Hạn sử dụng", align: "text-center", visible: true },
    {
      columnName: "Chức năng",
      align: "text-center",
      visible: false,
    },
  ];
  return observer(() => {
    // ============ Navigation =================/
    const navigate = useNavigate();
    // Lấy parameter trên url
    const { ReceiveId = "" } = useParams();
    // ==========================================//

    // ============ Loading toàn trang =========//
    const [loading, setLoading] = useState(true);
    //==========================================//
    // chi tiết lịch sử nhập kho
    const [detailsHistory, setDetailsHistory] = useState<
      DetailHistoryReceiveModel
    >();

    // Phân quyền nút lưu
    const [isSave, setIsSave] = useState(false);

    // //them dong moi
    // const [addColumn,setAddColumn] = useState<HistoryReceives[]>()
    //================================================================
    const handleOnAddNewColumn = () => {
      if (detailsHistory) {
        setDetailsHistory({
          ...detailsHistory,
          historyReceives: [
            ...detailsHistory.historyReceives,
            {
              id: "",
              lotNumber: "",
              quantity: 0,
              unit: "Cái",
              expirationDate: "",
            },
          ],
        });
      } else {
        console.log("co cc");
      }
    };
    const getDetail = async () => {
      await historyReceivePresenter.getDetailHistoryReceive(
        historyReceiveStore,
        ReceiveId
      );
      setDetailsHistory(historyReceiveStore.detailHistoryResponse.data);
      setHistory(
        historyReceiveStore.detailHistoryResponse.data?.historyReceives[0]
      );
    };
    // Kiểm tra phân quyền
    const pagePermissions = () => {
      // Kiểm tra đường dẫn
      // check phân quyền bằng đường dẫn
      // kiểm tra url của web để tìm page id => dùng page id để tìm quyền của trang
      const path = window.location.pathname;
      const user = getUserSession() as User;
      const filteredData = user.webPermission.pageModel.filter((item) => {
        const itemNames = item.pageUrl.split(" ");
        return itemNames.some((name) => path.includes(name));
      });

      if (filteredData.length) {
        // lấy ra danh sách quyền của trang
        const permission = user.webPermission.pagePermissionModel.filter(
          (item) => item.pageId === filteredData[0].pageId
        );
        if (permission.length) {
          // Kiểm tra quyền
          if (permission.findIndex((item) => item.functionId === "EDIT") > -1) {
            setIsSave(true);
          }
        }
      }
    };

    useEffect(() => {
      const getData = async () => {
        await getDetail();
        setLoading(false);
      };
      pagePermissions();
      getData();
    }, []);

    const [history, setHistory] = useState<HistoryReceives | undefined>();
    // =================================================================

    // =================================================================
    // LƯU SỬA XÓA
    // Sa phiếu nhập kho
    const handleEdit = async (history: HistoryReceives | undefined) => {
      setLoading(true);
      await historyReceivePresenter.editReceiveVote(historyReceiveStore, {
        receiveId: history?.id,
        lotNumber: history?.lotNumber,
        quantity: history?.quantity,
        expirationdate: history?.expirationDate,
      });
      setLoading(false);
      if (historyReceiveStore.editReceiveVoteResponse.isSuccess) {
        toast.success(historyReceiveStore.editReceiveVoteResponse.message);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error(historyReceiveStore.editReceiveVoteResponse.message);
      }
    };
    // Đông bộ
    const handleSync = async (history: HistoryReceives | undefined) => {
      setLoading(true);
      await historyReceivePresenter.syncReceive(historyReceiveStore, {
        receiveId: history?.id,
        lotNumber: history?.lotNumber,
        quantity: history?.quantity,
        expirationdate: history?.expirationDate,
      });

      if (historyReceiveStore.syncReceive.isSuccess) {
        toast.success(historyReceiveStore.syncReceive.message);
        setTimeout(() => {
          window.location.reload();
          setLoading(false);
        }, 1500);
      } else {
        toast.error(historyReceiveStore.syncReceive.message);
        setLoading(false);
      }
    };
    // lấy value edit
    const handleChangeValueEdit = (
      e: React.ChangeEvent<HTMLInputElement>,
      index: number
    ) => {
      // tạo biến tạm để update giá trị tại vị trí index
      const tempDetail = detailsHistory;
      const key = e.target.id;
      if (tempDetail) {
        if (key === "quantity") {
          tempDetail.historyReceives[index].quantity = Number(e.target.value);
          setHistory({
            id: tempDetail.historyReceives[index].id,
            lotNumber: tempDetail.historyReceives[index].lotNumber,
            quantity: Number(e.target.value),
            unit: tempDetail.historyReceives[index].unit,
            expirationDate: tempDetail.historyReceives[index].expirationDate,
          });
        } else if (key === "expirationDate") {
          if (e.target.value !== "") {
            tempDetail.historyReceives[index].expirationDate = e.target.value;
            setHistory({
              id: tempDetail.historyReceives[index].id,
              lotNumber: tempDetail.historyReceives[index].lotNumber,
              quantity: tempDetail.historyReceives[index].quantity,
              unit: tempDetail.historyReceives[index].unit,
              expirationDate: e.target.value,
            });
          } else {
            tempDetail.historyReceives[index].expirationDate = null;
          }
        } else if (key === "lotNumber") {
          tempDetail.historyReceives[index].lotNumber = e.target.value;
          setHistory({
            id: tempDetail.historyReceives[index].id,
            lotNumber: e.target.value,
            quantity: tempDetail.historyReceives[index].quantity,
            unit: tempDetail.historyReceives[index].unit,
            expirationDate: tempDetail.historyReceives[index].expirationDate,
          });
        }
        setDetailsHistory(tempDetail);
      }
    };

    // =================================================================

    return (
      <div className="relative w-full p-5 py-3">
        {loading && <LoadingScreen />}
        {/* nút back */}

        <div className="w-full md:flex items-center mb-2 md:justify-between">
          <div className="flex items-center">
            <h3 className="text-default font-bold text-gray-800 uppercase">
              Màn hình chi tiết
            </h3>
            <span
              onClick={() => navigate("/" + ROUTES.HISTORY_RECEIVE.BASE)}
              className="flex items-center text-xs text-primary cursor-pointer font-medium w-fit"
            >
              <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
              Quay lại
            </span>
          </div>
          {/* Nút lưu và lưu tiếp tục và thêm nút đồng bộ */}
          <div className="flex float-right my-2 md:my-0">
            {/* Kiểm tra xem có quyền edit hay không */}
            {/* Kiểm tra receiveCode có == 0 hay không, nếu == 0 thì cho lưu, ngược lại hiện nút đồng bộ */}
            {isSave ? (
              detailsHistory?.receiveCode !== "0" ? (
                <button
                  onClick={() => handleEdit(history)}
                  disabled={loading}
                  className="flex items-center rounded-base bg-primary text-white text-default py-1 px-2.5 mr-3 disabled:bg-gray-600"
                >
                  <BiSave className="text-base mr-0.5" />
                  Lưu
                </button>
              ) : (
                <button
                  onClick={() => handleSync(history)}
                  disabled={loading}
                  className={`flex items-center rounded-base bg-primary text-white text-default py-1 px-2.5 mr-3 hover:opacity-80 disabled:bg-gray-600`}
                >
                  <ChangeCircleIcon className="text-base mr-0.5" />
                  Đồng bộ
                </button>
              )
            ) : (
              ""
            )}
          </div>
          {/* detailsHistory?.receiveCode */}
        </div>
        {/* ================================================================= */}
        <div className="w-full bg-white p-3.5 flex rounded mb-2 border border-neutral-300">
          <form className="w-full flex flex-col mx-auto">
            <div className="w-full sm:w-3/5 mx-auto text-[13px]">
              {/* Số phiếu nhập kho*/}
              <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="col-span-7 lg:col-span-2 font-bold text-gray-700 text-left lg:text-right">
                  Số phiếu nhập kho
                </label>
                <input
                  disabled
                  value={detailsHistory?.receiveCode || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Lệnh sản xuất*/}
              <div className="sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="col-span-7 lg:col-span-2 font-bold text-gray-700 text-left lg:text-right">
                  Lệnh sản xuất
                </label>
                <input
                  disabled
                  value={detailsHistory?.workOrderCode || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>

              {/* mã TP/BTP*/}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Mã TP/BTP
                </label>
                <input
                  disabled
                  value={detailsHistory?.productCode || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* TP/BTP*/}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Tên TP/BTP
                </label>
                <input
                  disabled
                  value={detailsHistory?.productName || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Số thẻ treo*/}
              {/* <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Số thẻ treo
                </label>
                <input
                  disabled
                  value={detailsHistory?.kssxNumber || ''}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div> */}
              {/*  Mã công đoạn nhập kho*/}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Mã công đoạn nhập kho
                </label>
                <input
                  disabled
                  value={detailsHistory?.stepCode || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/*  Tên Công đoạn nhập kho*/}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Tên Công đoạn nhập kho
                </label>
                <input
                  disabled
                  value={detailsHistory?.stepName || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Tình trạng TP/BTP nhập kho */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Tình trạng TP/BTP nhập kho
                </label>
                <input
                  disabled
                  value={detailsHistory?.statusReceive || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Số lần nhập kho */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Lần nhập kho
                </label>
                <input
                  disabled
                  value={"Lần " + detailsHistory?.receiveQty || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Ghi chú */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Ghi chú
                </label>
                <textarea
                  disabled
                  value={detailsHistory?.description || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Work Order Completion */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Work Order Completion
                </label>
                <input
                  disabled
                  value={detailsHistory?.woCompletion || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Ngày chứng từ */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Ngày chứng từ
                </label>
                <input
                  disabled
                  value={
                    detailsHistory?.tranDate
                      ? moment(detailsHistory?.tranDate).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )
                      : ""
                  }
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Thời gian nhập kho */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Thời gian nhập kho
                </label>
                <input
                  disabled
                  value={
                    detailsHistory?.receiveTime
                      ? moment(detailsHistory?.receiveTime).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )
                      : ""
                  }
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
              {/* Người nhập kho */}
              <div className=" sm:flex-row mb-3 sm:items-center grid grid-cols-7 lg:gap-2">
                <label className="font-bold col-span-7 lg:col-span-2 text-gray-700 text-left lg:text-right">
                  Người nhập kho
                </label>
                <input
                  disabled
                  value={detailsHistory?.receiveBy || ""}
                  className="col-span-7 lg:col-span-4 bg-gray-100 text-gray-700 border border-gray-300 px-3 py-1.5 text-default focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                />
              </div>
            </div>
          </form>
        </div>
        {/* ================================================================== */}

        {/* ================================================================= */}
        <div className="w-full flex justify-center bg-white p-3.5 rounded mb-2 border border-neutral-300">
          <div
          // className="sm:w-3/5 mx-auto"
          >
            <div className={`overflow-x-auto my-3`}>
              <table className="text-default table-auto border-collapse space-collapse text-default`">
                <thead className="font-medium text-gray-700 bg-gray-100">
                  <tr>
                    {column?.map((item, index) => {
                      if (item.visible) {
                        return (
                          <th
                            key={index}
                            scope="col"
                            className={`${
                              item.visible ? "" : "hidden"
                            } py-1.5 px-5 border whitespace-nowrap text-left ${
                              item.align
                            }`}
                          >
                            {item.columnName}
                          </th>
                        );
                      }
                    })}
                  </tr>
                </thead>
                <tbody>
                  {detailsHistory?.historyReceives.length ? (
                    detailsHistory.historyReceives.map((row, index) => (
                      <tr
                        className={`${
                          index % 2 !== 0 ? "bg-gray-50" : "bg-white"
                        } hover:bg-gray-100`}
                        key={index}
                      >
                        {/* Số thứ tự */}
                        <td className="border whitespace-nowrap text-center">
                          {index + 1}
                        </td>
                        {/* Số lot*/}
                        <td className="border whitespace-nowrap px-2">
                          {/* {row.lotNumber} */}
                          <input
                            value={row.lotNumber}
                            id="lotNumber"
                            onChange={(e) => handleChangeValueEdit(e, index)}
                            className="text-gray-700 border border-gray-300 px-1 py-0.25 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </td>
                        {/* Số lượng nhập kho*/}
                        <td className="border whitespace-nowrap px-2 text-right">
                          {/* {formatNumber(row.quantity, 0)} */}
                          <input
                            value={row.quantity || 0}
                            id="quantity"
                            onChange={(e) => handleChangeValueEdit(e, index)}
                            className="text-gray-700 border border-gray-300 px-1 py-0.25 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 text-right"
                          />
                        </td>
                        {/* Đơn vị tính*/}
                        <td className="border whitespace-nowrap px-2">
                          {row.unit}
                        </td>
                        {/* Hạn sử dụng*/}
                        <td className="border whitespace-nowrap px-2">
                          {/* {row.expirationDate && moment(row.expirationDate).format('DD/MM/YYYY HH:MM')} */}
                          <input
                            type="date"
                            id="expirationDate"
                            onChange={(e) => handleChangeValueEdit(e, index)}
                            value={moment(row.expirationDate).format(
                              "YYYY-MM-DD"
                            )}
                            className="text-gray-700 border border-gray-300 px-1 py-0.25 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                          />
                        </td>
                        {/* chuc nang */}
                        {/* <td className="py-1 px-2 border whitespace-nowrap flex justify-center gap-4">
                          <span className="grid grid-cols-2 gap-2">
                            <button
                              onClick={() => handleEdit(row)}
                              className={`text-default ${
                                row.id === '' ? 'bg-primary text-white' : 'bg-btn_edit'
                              } py-0.25 rounded-base px-2.5  border-gray-300 border flex gap-1 items-center justify-center`}
                            >
                              {row.id === '' ? 'Lưu' : 'Sửa'}
                            </button>
                            <button className="text-default bg-danger text-white py-0.25 rounded-base px-2.5  border-danger border flex gap-1 items-center justify-center">
                              Xóa
                            </button>
                          </span>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        className="border whitespace-nowrap px-2 py-1 text-center"
                        colSpan={12}
                      >
                        Không tìm thấy dòng nào phù hợp
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* <button
              onClick={() => handleOnAddNewColumn()}
              type="button"
              className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 mt-1 text-center focus:outline-none hover:bg-blue-600`}
            >
              <>
                <IoAddSharp className="font-bold text-default" />
                <span>Thêm dòng</span>
              </>
            </button> */}
          </div>
        </div>
        {/* ================================================================== */}
      </div>
    );
  });
}
